/**
 * MineraliA: búsquedas recientes del visitante.
 * Se guardan sólo en su navegador (localStorage), hasta 6, sin duplicados. Se registran al llegar a la
 * página de resultados con `?q=`, y se muestran como píldoras en el buscador antes de escribir.
 */
const STORAGE_KEY = 'mineralia-recent-searches';
const MAX_TERMS = 6;

function readTerms() {
  try {
    const terms = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(terms) ? terms.filter((term) => typeof term === 'string' && term.trim()) : [];
  } catch {
    return [];
  }
}

function writeTerms(terms) {
  try {
    if (terms.length) localStorage.setItem(STORAGE_KEY, JSON.stringify(terms));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {}
}

function rememberTerm(term) {
  const clean = term.trim().replace(/\s+/g, ' ').slice(0, 60);
  if (clean.length < 2) return;
  const terms = readTerms().filter((saved) => saved.toLowerCase() !== clean.toLowerCase());
  writeTerms([clean, ...terms].slice(0, MAX_TERMS));
}

class MineraliaRecentSearches extends HTMLElement {
  // El buscador predictivo transforma (morph) este marcado con el del servidor, que llega vacío y
  // oculto: al volver a ponerse `hidden` se repinta la lista.
  static observedAttributes = ['hidden'];

  attributeChangedCallback() {
    if (this.rendering || !this.isConnected) return;
    queueMicrotask(() => this.render());
  }

  connectedCallback() {
    this.render();
    if (this.listening) return;
    this.listening = true;
    this.addEventListener('click', (event) => {
      if (!event.target.closest('[data-recent-clear]')) return;
      writeTerms([]);
      this.render();
      // Devuelve el foco al buscador para no perderlo al ocultar el grupo.
      this.closest('dialog, form, .predictive-search-form')?.querySelector('input[type="search"]')?.focus();
    });
  }

  render() {
    this.rendering = true;
    const list = this.querySelector('[data-recent-list]');
    if (!list) {
      this.rendering = false;
      return;
    }
    const terms = readTerms();
    const searchUrl = this.dataset.searchUrl || '/search';
    list.replaceChildren(
      ...terms.map((term) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'pills__pill predictive-search-results__pill mineralia-search-shortcuts__pill';
        link.href = `${searchUrl}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
        link.innerHTML =
          '<span class="svg-wrapper mineralia-search-shortcuts__icon" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="10" cy="10" r="7"/><path d="M10 6v4l2.5 2"/></svg></span>';
        link.append(term);
        item.append(link);
        return item;
      })
    );
    this.hidden = terms.length === 0;
    this.rendering = false;
  }
}

// Registra la búsqueda actual al llegar a la página de resultados (antes de pintar la lista).
const searchPath = document.querySelector('mineralia-recent-searches')?.dataset.searchUrl || '/search';
if (window.location.pathname === searchPath) {
  const query = new URLSearchParams(window.location.search).get('q');
  if (query) rememberTerm(query);
}

if (!customElements.get('mineralia-recent-searches')) {
  customElements.define('mineralia-recent-searches', MineraliaRecentSearches);
}
